import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useContext, useMemo, useState } from "react";
import { Context } from "../..";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { useModal } from "../../hooks/useModal";
import DeliveryModal from "../Shipping/DeliveryModal";
import PickupModal from "../Shipping/PickupModal";
import ButtonUI from "../UI/ButtonUI/ButtonUI";
import InputUI from "../UI/Input/Input";
import DeliveryTypes from "./DeliveryTypes";
import {getPickupType} from "../../utils/format";
import { ReactComponent as AlertIcon } from "../../assets/icons/alert.svg";
import "./styles.scss";
import {formatDeliveryDate} from "../../utils/date";

const AddressStep = observer(function AddressStep({ onSelectAddress, onPvzInfoClick, onPvzSelect, onChangeCity, pickupSource, allowCourier = true,
  preorderMode = false }) {
  const isTablet = useMediaQuery("(max-width: 1024px)");
  const {
    isModalOpen: isModalPickupModal,
    openModal: isModalPickupModalOpen,
    closeModal: isModalPickupModalClose,
  } = useModal();
  const {
    isModalOpen: isModalDeliveryModal,
    openModal: isModalDeliveryModalOpen,
    closeModal: isModalDeliveryModalClose,
  } = useModal();
  const [isNewAddress, setIsNewAddress] = useState(true);
  const { basket, user, delivery } = useContext(Context);


  const handleOpenModal = () => {
    if (onChangeCity) return onChangeCity();
    user.setShadowOverlay(true);
    basket.setFunctionalModalState(1);
  };

  const IS_PICKUP = useMemo(() => {
    
    return !!delivery.officePvz;
  }, [delivery.officePvz]);

  const IS_DELIVERY = useMemo(() => {
    return !!delivery.selectedAddress
  }, [delivery.selectedAddress]);

  const hasPickup = useMemo(() => {
    if (delivery.cityInfo) {
      return delivery.cityInfo.data.country_iso_code === "RU";
    }
    return true;
  }, [delivery.cityInfo]);

  const notRu = useMemo(() => {
    if (delivery.cityInfo) {
      return delivery.cityInfo.data.country_iso_code !== "RU";
    }
    return true;
  }, [delivery.cityInfo]);

  const PickupSelect = () => {
    
    isModalPickupModalClose()
    if(onPvzSelect) onPvzSelect()
  }
  const openPickup = () => {
    if (pickupSource?.onOpen) pickupSource.onOpen();
    isModalPickupModalOpen();
  };

  return (
    <>
      {isNewAddress ? (
        <>
          <div className="address-step">
            <div className="address-step__top">
              <InputUI
                text="Населенный пункт"
                className="address-step__input"
                value={delivery?.cityInfo?.value ?? ""}
                onClick={isTablet ? handleOpenModal : () => { }}
                disabled={!isTablet}
              />
              {!isTablet && (
                <ButtonUI
                  text="Изменить"
                  type="button"
                  theme="outline"
                  className="address-step__change"
                  onClick={handleOpenModal}
                />
              )}
            </div>
            <div
              className={clsx("address-step__shipping", {
                _disabled: !delivery?.cityInfo?.value,
              })}
            >
              {hasPickup && (
                <div
                  className={clsx("address-step__shipping-item", {
                    _active: IS_PICKUP,
                  })}
                  onClick={openPickup}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.0994 20H13.3836H17.5379H20.8983M19.6151 20V9.64356M19.6151 9.64356C19.0612 9.9512 18.4139 10.0649 17.783 9.96545C17.152 9.86598 16.5762 9.55942 16.1531 9.09778C15.6454 9.65067 14.9032 10 14.076 10C13.683 10.0004 13.2944 9.92 12.9362 9.76426C12.578 9.60852 12.2584 9.381 11.9988 9.09689C11.4911 9.65067 10.7489 10 9.92169 10C9.52867 10.0004 9.14009 9.92 8.7819 9.76426C8.42371 9.60852 8.10414 9.381 7.84454 9.09689C7.42165 9.55868 6.84588 9.8654 6.21489 9.96504C5.5839 10.0647 4.93655 9.9511 4.38262 9.64356M19.6151 9.64356C19.983 9.43903 20.2972 9.15572 20.5333 8.81557C20.7693 8.47541 20.9209 8.08752 20.9763 7.68191C21.0318 7.27631 20.9895 6.86386 20.8529 6.47649C20.7162 6.08912 20.4889 5.73721 20.1884 5.448L19.0898 4.39111C18.8303 4.14099 18.4783 4.00031 18.1112 4H5.88555C5.51855 4.00008 5.16658 4.14043 4.90698 4.39022L3.80932 5.448C3.50951 5.73754 3.28276 6.08952 3.14655 6.47678C3.01033 6.86404 2.9683 7.27624 3.0237 7.68161C3.07909 8.08699 3.23042 8.4747 3.46603 8.81486C3.70164 9.15501 4.01522 9.43853 4.38262 9.64356M4.38262 20V9.64356"
                      stroke="#1B1B1B"
                      strokeWidth="1.3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <span className="address-step__shipping-info">
                    <span className="address-step__shipping-info-title">
                      Самовывоз
                    </span>
                    <span className="address-step__shipping-info-text">
                      ПВЗ
                    </span>
                  </span>

                  {!preorderMode && !!basket.delPrice && IS_PICKUP && (
                    <span className="address-step__shipping-info-price">
                      {basket.delPrice} ₽
                    </span>
                  )}
                </div>
              )}

              {allowCourier && <div
                className={clsx("address-step__shipping-item", {
                  _active: IS_DELIVERY,
                })}
                onClick={isModalDeliveryModalOpen}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.25002 18.75C8.25002 19.1478 8.09198 19.5293 7.81068 19.8107C7.52937 20.092 7.14784 20.25 6.75002 20.25C6.35219 20.25 5.97066 20.092 5.68936 19.8107C5.40805 19.5293 5.25002 19.1478 5.25002 18.75M8.25002 18.75C8.25002 18.3522 8.09198 17.9706 7.81068 17.6893C7.52937 17.408 7.14784 17.25 6.75002 17.25C6.35219 17.25 5.97066 17.408 5.68936 17.6893C5.40805 17.9706 5.25002 18.3522 5.25002 18.75M8.25002 18.75H14.25M5.25002 18.75H3.37502C3.07665 18.75 2.7905 18.6315 2.57952 18.4205C2.36855 18.2095 2.25002 17.9234 2.25002 17.625V14.25M14.25 18.75H16.5M14.25 18.75V14.25M2.25002 14.25V6.61499C2.24843 6.34116 2.34848 6.07648 2.53081 5.87217C2.71313 5.66786 2.96477 5.53845 3.23702 5.50899C6.57006 5.16302 9.92997 5.16302 13.263 5.50899C13.828 5.56699 14.25 6.04699 14.25 6.61499V7.57299M2.25002 14.25H14.25M19.5 18.75C19.5 19.1478 19.342 19.5293 19.0607 19.8107C18.7794 20.092 18.3978 20.25 18 20.25C17.6022 20.25 17.2207 20.092 16.9394 19.8107C16.6581 19.5293 16.5 19.1478 16.5 18.75M19.5 18.75C19.5 18.3522 19.342 17.9706 19.0607 17.6893C18.7794 17.408 18.3978 17.25 18 17.25C17.6022 17.25 17.2207 17.408 16.9394 17.6893C16.6581 17.9706 16.5 18.3522 16.5 18.75M19.5 18.75H20.625C21.246 18.75 21.754 18.246 21.715 17.626C21.5141 14.3236 20.4019 11.1416 18.502 8.43299C18.3211 8.17927 18.0848 7.97001 17.8111 7.82102C17.5373 7.67203 17.2333 7.58722 16.922 7.57299H14.25M14.25 7.57299V14.25"
                    stroke="#1B1B1B"
                    strokeWidth="1.3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <span className="address-step__shipping-info">
                  <span className="address-step__shipping-info-title">Курьер</span>
                  <span className="address-step__shipping-info-text">
                    служба доставки
                  </span>
                </span>

                {!preorderMode && !!basket.delPrice && IS_DELIVERY && (
                  <span className="address-step__shipping-info-price">
                    {basket.delPrice} ₽
                  </span>
                )}
              </div>}
            </div>

            {IS_DELIVERY && (
              <>
                {notRu ? (
                  <div className="address-step__warning">
                    <AlertIcon />
                    Доставка будет рассчитана отдельно для заказов менее 25000
                  </div>
                ) : (
                  <div className="address-step__warning">
                    <AlertIcon />
                    Примерка доступна только при доставке курьером по Москве
                  </div>
                )}
              </>
            )}
          </div>

          {allowCourier && <DeliveryModal
            isModalOpen={isModalDeliveryModal}
            closeModal={isModalDeliveryModalClose}
            preorderMode={preorderMode}
          />}
          <PickupModal
            isModalOpen={isModalPickupModal}
            closeModal={isModalPickupModalClose}
            selectPickup={PickupSelect}
            pickupSource={pickupSource}
          />

          {IS_PICKUP && (
            <div className="selected-pickup">
              <div className="selected-pickup__info">
                <span className="selected-pickup__info-title">
                  {getPickupType(delivery.officePvz.pickupType)}
                  <AlertIcon onClick={onPvzInfoClick} />
                </span>
                <span className="selected-pickup__info-address">
                  {delivery.officePvz.addressFields?.street || delivery.officePvz.address}
                </span>
                {!preorderMode && (delivery.officePvz.deliveryNotice || delivery.officePvz.deliveryTerm) && (
                  <span className="selected-pickup__info-term">
                    {
                      delivery.officePvz.deliveryNotice || formatDeliveryDate(delivery.officePvz.deliveryTerm)
                    }

                  </span>
                )}
              </div>
              <ButtonUI
                text="Выбрать другой"
                type="button"
                theme="outline"
                className="address-step__change _pickup"
                onClick={openPickup}
              />

            </div>
          )}

          {IS_DELIVERY && (
            <div className="selected-delivery">
              <div className="selected-delivery__wrapper">
                <div className="selected-delivery__info">
                  <span className="selected-delivery__info-title">Адрес</span>
                  <span className="selected-delivery__info-value">
                    {delivery.selectedAddress?.addressFields?.all?.value || delivery.selectedAddress?.all?.value}
                    {(delivery.selectedAddress?.addressFields?.apartment || delivery.selectedAddress?.apartment) && (
                        <span>, кв. {delivery.selectedAddress?.addressFields?.apartment || delivery.selectedAddress?.apartment}</span>
                    )}
                  </span>
                </div>


                {(delivery.selectedAddress?.addressFields?.comment || delivery.selectedAddress?.comment) && (
                  <div className="selected-delivery__info">
                    <span className="selected-delivery__info-title">Комментарий</span>
                    <span className="selected-delivery__info-value">
                      {delivery.selectedAddress?.addressFields?.comment || delivery.selectedAddress?.comment}
                    </span>
                  </div>
                )}
              </div>
              <DeliveryTypes />
            </div>
          )}
        </>
      ) : (
        <>
          <button
            className="address-step__new"
            type="button"
            onClick={() => setIsNewAddress(true)}
          >
            <div className="address-step__new-info">
              <span className="address-step__new-info-title">Новый адрес</span>
              <span className="address-step__new-info-text">
                курьер или самовывоз
              </span>
            </div>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.5 3L10.5 8L5.5 13"
                stroke="#1B1B1B"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          {/*<AddressList onSelectAddress={onSelectAddress} />*/}
        </>
      )}
    </>
  );
});

export default AddressStep;
